// extracted by mini-css-extract-plugin
export default {"wrap":"wrap---i9otb","centered":"centered---TzZvX"};